'use strict';

angular.module('userRequestProcessControllers', ['ngSanitize'])

    .controller('CardSystemRolePendingController', ['$scope', 'processAccessRequestService', '$sanitize', function ($scope, processAccessRequestService, $sanitize) {

    $scope.systemRolePendings = $scope.card.UserAccessRequestSystem.SystemRolePendings;
    $scope.userCustodianName = $scope.userCustodianName;
    $scope.employeeDisplayName = $scope.userAccessRequest.Employee.DisplayName;
    $scope.employeeID = $scope.userAccessRequest.Employee.EmployeeID;
    $scope.isRequestPostDated = $scope.userAccessRequest.RequestStatus === "Authorized, Post-Dated";

    $scope.card.Username = $scope.card.UserAccessRequestSystem.Username;
    $scope.StateProcessingSystemAccount = null;
    $scope.urlRegex = /((?:(ftp|https|http?):(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/g
    $scope.isConfirming = false;

    $scope.init = function (newIamUrl) {
        $scope.newIamUrl = newIamUrl;
        $scope.initializeUserAccessRequestSystem();
    }

    $scope.initializeUserAccessRequestSystem = function () {
        _.forEach($scope.systemRolePendings, function (role) {
            if (role.SystemRoleResourcePendings.length > 0) {
                _.forEach(role.SystemRoleResourcePendings, function (resource) {
                    if (!resource.IsAutomated && resource.HelperText) {
                        resource.isTextLongEnoughToCollapse = resource.HelperText.length > 50;
                        resource.HelperText = $scope.urlifyText(resource.HelperText);
                        resource.isCollapsed = resource.isTextLongEnoughToCollapse;
                        resource.collapsibleClass = 'res-collapsed';
                        resource.collapseLabelClass = 'fa-caret-down';
                    }
                });

                role.SystemRoleResourcePendings = _.sortBy(role.SystemRoleResourcePendings, 'Sequence');

                var canProcessFirstProvStep = role.SystemRoleResourcePendings[0].IsAutomated || role.SystemRoleResourcePendings[0].LastProvisioningEventID !== 0;
                // !role.IsProcessed to check for processed accesses pre-access 2.0 migration that do not have events
                if (!$scope.isRequestPostDated && !role.IsCancelled && !role.IsProcessed && !role.NeedSystemOwnerApprobation && !role.NeedITPurchasingApprobation && !canProcessFirstProvStep)
                    role.ShowCardDetails = false;
                else
                    role.ShowCardDetails = true;
            }

            $scope.setCurrentResource(role);
        });
    }

    $scope.setCurrentResource = function (role) {
        var currentResource = null;
        if (!role.NeedSystemOwnerApprobation && !role.NeedITPurchasingApprobation && !role.IsCancelled && !$scope.isRequestPostDated)
            currentResource = _.head(_.filter(role.SystemRoleResourcePendings, r => !r.IsProcessed));

        if (currentResource) {
            currentResource.IsCurrent = true;

            if (currentResource.LastProvisioningEventTaskStateStatusName === 'NEED_RETRY')
                currentResource.ErrorURL = $scope.newIamUrl + "/Search/ControlCenter?facets=" +
                    "EmployeeDisplayName%3D" + $scope.employeeDisplayName + ";" +
                    "TaskStateStatusName_TaskStateStatusName%3D" + currentResource.LastProvisioningEventTaskStateStatusName + ";" +
                    "EventTypeName_EventTypeName%3D" + currentResource.LastProvisioningEventTypeShortDescription + ";" +
                    "IsCompleted%3DNot%20completed";
        }
    }

    $scope.toggleIsCollapsed = function (resource) {
        resource.isCollapsed = !resource.isCollapsed;
        if (resource.isCollapsed) {
            resource.collapseLabelClass = 'fa-caret-down';
            resource.collapsibleClass = 'res-collapsed';
        }
        else {
            resource.collapseLabelClass = 'fa-caret-up';
            resource.collapsibleClass = 'res-not-collapsed';
        }
    }

    $scope.$watch('card.Username', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (_.isEmpty(newVal)) return;

            $scope.StateProcessingSystemAccount = 'CheckAvailability';
            processAccessRequestService.checkAvailabilityForSystemAccount($scope.card.UserAccessRequestSystem.SystemID, newVal)
                .then(function (isAvailable) {
                    if (isAvailable) $scope.StateProcessingSystemAccount = 'Available';
                    else $scope.StateProcessingSystemAccount = 'NotAvailable';
                });
        }
    });

    // Confirm manual step
    $scope.confirm = function (resourcePending, systemRolePending) {
        if ($scope.isConfirming) {
            return;
        }

        $scope.isConfirming = true;

        switch (resourcePending.ResourceTypeName) {
            case 'System Account':
                if (systemRolePending.ToAdd) {
                    processAccessRequestService
                        .createSystemAccount(resourcePending.LastProvisioningEventID, $scope.card.UserAccessRequestSystem.UserAccessRequestID,
                                             systemRolePending.UserAccessRequest_SystemRolePendingID, resourcePending.SystemRoleResourcePendingID,
                                             $scope.employeeID, $scope.card.UserAccessRequestSystem.SystemID, $scope.card.Username)
                        .then(function (response) {
                            if (response.UserAccessRequestSystem) {
                                $scope.handleManualStepResponse(response);
                            }
                        })
                        .finally(function () {
                            $scope.isConfirming = false;
                        });
                }
                else if (systemRolePending.ToRemove) {
                    processAccessRequestService
                        .removeSystemAccount(resourcePending.LastProvisioningEventID, $scope.card.UserAccessRequestSystem.UserAccessRequestID,
                                             systemRolePending.UserAccessRequest_SystemRolePendingID, resourcePending.SystemRoleResourcePendingID,
                                             $scope.employeeID, $scope.card.UserAccessRequestSystem.SystemID)
                        .then(function (response) {
                            if (response.UserAccessRequestSystem) {
                                $scope.handleManualStepResponse(response);
                            }
                        })
                        .finally(function () {
                            $scope.isConfirming = false;
                        });
                    }
                break;

            case 'System Provisioning':
            case 'Special Instructions':
                processAccessRequestService
                    .confirmManualStep(resourcePending.LastProvisioningEventID, $scope.card.UserAccessRequestSystem.UserAccessRequestID,
                                         systemRolePending.UserAccessRequest_SystemRolePendingID, resourcePending.SystemRoleResourcePendingID,
                                         $scope.card.UserAccessRequestSystem.SystemID)
                    .then(function (response) {
                        if (response.UserAccessRequestSystem) {
                            $scope.handleManualStepResponse(response);
                        }
                    })
                    .finally(function () {
                        $scope.isConfirming = false;
                    });
                break;

            default:
              $scope.isConfirming = false;

              break;
		}
    }

    $scope.handleManualStepResponse = function (response) {
        $scope.systemRolePendings = response.UserAccessRequestSystem.SystemRolePendings;
        $scope.card.Username = response.UserAccessRequestSystem.Username;
        $scope.initializeUserAccessRequestSystem();

        $scope.card.IsProcessed = response.IsCardProcessed;
    }

    $scope.isSystemAccount = function (resourcePending) {
        return (resourcePending.ResourceTypeName == 'System Account');
    }
    $scope.isSystemProvisioning = function (resourcePending) {
        return ( resourcePending.ResourceTypeName == 'System Provisioning');
    }
    $scope.isSpecialInstructions = function (resourcePending) {
        return (resourcePending.ResourceTypeName == 'Special Instructions');
    }

    $scope.isStepEnabled = function (rolePending, resourcePending) {
        if ($scope.isRequestPostDated)
            return false;

        if (!rolePending.ShowCardDetails)
            return false;

        if (_.includes($scope.authenticatedUser.UserADGroups, 'id-admin') || _.includes($scope.authenticatedUser.UserADGroups, 'id-custodian-btgaccessmgmt'))
            return true;

        if ($scope.userCustodianName)
            return resourcePending.CustodianName?.toLowerCase() == $scope.userCustodianName.toLowerCase();

        return false;
    }

    $scope.escapeHtml = function (str) {
      const entityMap = {
        "<": "&lt;",
        ">": "&gt;",
      };

      return String(str).replace(/[<>]/g, function (s) {
          return entityMap[s];
      });
    }

    $scope.urlifyText = function (text) {
        var escapedText = $scope.escapeHtml(text);
        var html = escapedText.replace($scope.urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>';
        });

        return $sanitize(html);
    }

}]);

